"use strict";

// $(function(){
//   $('#fullpage').fullpage({
//     anchors: ['no00', 'no01', 'no02', 'no03'],
//     // menu: '#side-nav',
//     scrollOverflow: true
//   });

//   $(window).on('load resize', function () {
//     responsive();
//   });

//   function responsive() {
//     var w = $(window).width();
//     if ( w <= 768 ) {
//       $.fn.fullpage.setResponsive(true);
//     } else {
//       $.fn.fullpage.setResponsive(false);
//     }
//   }

// });

$(document).ready(function() {
  var w = $(window).width();
  if (w > 768) {
    $('#fullpage').fullpage({
      anchors: ['no00', 'no01', 'no02', 'no03'],
      scrollOverflow: true,
      responsiveWidth: 768,
      afterResponsive: function(isResponsive){
        $(window).on('load resize', function () {
          var height= $(window).height();
            $('.section').css('height', height - 50);
            $('.section .fp-tableCell').css('height', height - 50);
            $('.fp-tableCell').css('vertical-align','top');
        });
      },
      afterLoad: function(anchorLink, index) {
        var loadedSection = $(this);

        if (index == 2) {
          $('.business-left__overlay--01').addClass("on");
          $('.business-left__left--01').addClass("opacity");
          $('.business-left__right').addClass("opacity");
        }

        // Slide #3 is loaded
        else if (index == 3) {
          $('.business-right__overlay--02').addClass("on");
          $('.business-left__left--02').addClass("opacity");
          $('.business-right__right').addClass("opacity");
        }

        // Slide #4 is loaded
        else if (index == 4) {
          $('.business-left__overlay--03').addClass("on");
          $('.business-left__left--03').addClass("opacity");
          $('.business-left__right').addClass("opacity");
        }
      },
    });
  }
  else {
    window.addEventListener("scroll", function() {
      addClassWithScrollElement(".anim", "on", 4);
    });
  }
});


function addClassWithScrollElement(selector, className, perNum) {
  let elements = document.querySelectorAll(selector);
  Array.prototype.forEach.call(elements, function (element, index) {
      // windowの高さ - a
      let windowHeight = window.document.documentElement.clientHeight;

      // 現在のスクロール量
      let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
      // 画面左上から要素までの高さ - b
      let rect = element.getBoundingClientRect();
      let offset = rect.top + scrollTop;
      // 要素が画面に表示されるスクロール量(a - b)
      let scrollHeight = offset - windowHeight;

      // 画面の1/perNumを超えたら、classを追加
      if (scrollTop > scrollHeight + windowHeight / perNum) {
        element.classList.add(className);
      }
  });
}
